export enum EOperationStatus {
    PENDING = 'PENDING',
    SUCCESS = 'SUCCESS',
    FAIL = 'FAIL',
    UNKNOWN = 'UNKNOWN'
}

export interface IOperation<Data = any, Meta = any, Error = any> {
    id: string
    status: EOperationStatus,
    error: Error,
    progress?: number;
    error_message: string | null;
    data: Data;
    meta: Meta;
}

export interface IOperationsMap {
    [id: string]: IOperation
}
